export class IndicatifEntity {
    id!: number;
    countryName!: string;
    dialCode!: string;
    countryCode!: string;

    constructor() {
    }
}